import { Box, Tooltip, Zoom } from "@mui/material";
import { useConfirm } from "material-ui-confirm";
import { Client } from "../../API";
import DeleteIconButton from "../../common/components/icons/DeleteIconButton";
import confirmDialogStyleOptions from "../../common/helpers/confirmDialogParams";
import { useCustomerIdGuard } from "../../common/hooks/useCustomerIdGuard";
import { useDeleteFolderFromS3 } from "../../common/hooks/useDeleteFolderFromS3";
import { useDeleteClient } from "../hooks/useDeleteClient";

type DeleteClientContainerProps = {
  row: Omit<Client, "__typename">;
  disabled?: boolean;
};

const DeleteClientContainer = ({
  row,
  disabled,
}: DeleteClientContainerProps): JSX.Element => {
  const confirm = useConfirm();
  const { deleteFolderFromS3 } = useDeleteFolderFromS3();

  const { deleteClient, loading } = useDeleteClient();
  const customerId = useCustomerIdGuard();

  const handleClick = (): void => {
    confirm({
      title: `Are you sure you want to delete the client ${row.clientName}?`,
      confirmationText: "Delete",
      cancellationText: "Cancel",
      ...confirmDialogStyleOptions,
      confirmationButtonProps: {
        ...confirmDialogStyleOptions.confirmationButtonProps,
        disabled: loading,
      },
    }).then(async (): Promise<void> => {
      await deleteClient({ customerId: row.customerId, clientId: row.id });

      const folderToDelete = customerId + "/" + row.id;

      try {
        await deleteFolderFromS3({ folderPath: folderToDelete });
      } catch (error) {
        console.error(error);
      }
    });
  };

  return (
    <Tooltip
      TransitionComponent={Zoom}
      arrow
      disableInteractive
      placement="left"
      title="Delete"
    >
      <Box
        component="span"
        sx={{
          height: "32px",
        }}
      >
        <DeleteIconButton onClick={handleClick} disabled={disabled} />
      </Box>
    </Tooltip>
  );
};

export default DeleteClientContainer;
